// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8754b594","667":"75e2c1ee","977":"950fa7f9"}[chunkId] + ".chunk.js";
};